import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("fabriko_token");
export const setToken = (t) => {
  if (t) localStorage.setItem("fabriko_token", t);
  else localStorage.removeItem("fabriko_token");
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
